module.exports = __webpack_public_path__ + "img/auth_form.5c17c2ff.png";